import React, { useState } from "react";
import styled from "styled-components";
import Wp3Dropdown from "../../components/utilities/Dropdown";
import { Main, PageHeader, PageSubHeader, ThemedIcon, ThemedParagraph } from "../../components/utilities";
import { ClientManagementGrid } from "./components";
import { Button, IconButton } from "../../components";
import { useFilterContext } from "../../hooks/FilterContext";
import { ClientManagementFiltersModal } from "../clientmanagementfilters";
import { FormInputWithSearchIcon } from "../../components/forms";

const ClientManagementHeaderTitle = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;

    & > span:not(:last-child) {
        margin-right: 1rem;
    }
`;

const ClientManagementPageSubHeader = styled(PageSubHeader)`
    position: sticky;
    padding: 0.75rem;
`;

const ClientManagementFiltersAppliedWarningMessage = styled(ThemedParagraph)`
    font-size: 12px !important;
    justify-content: space-between !important;
`;

const ClientManagement = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const [isFiltersShown, setIsFiltersShown] = useState(false);
    const [showCreateSetModal, setShowCreateSetModal] = useState(false);

    const {
        clearFilter,
        isFiltersApplied,
    } = useFilterContext();

    return (
        <React.Fragment>
            <ClientManagementFiltersModal
                handleClose={() => setIsFiltersShown(false)}
                show={isFiltersShown}
            />
            <PageHeader>
                <ClientManagementHeaderTitle>
                    <span>Client Management</span>
                </ClientManagementHeaderTitle>
            </PageHeader>
            <Main className="d-flex flex-column">
                <ClientManagementPageSubHeader>
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center">
                            {isFiltersApplied && (
                                <React.Fragment>
                                    <ThemedIcon className="my-auto" icon="fa-triangle-exclamation" size="2x" variant="warning" />
                                    <ClientManagementFiltersAppliedWarningMessage className="ms-2 text-muted">
                                        Warning - Filters are currently being applied to your results.
                                        <br />
                                        <button className="anchor" onClick={clearFilter}>Click here</button> to clear your filters.
                                    </ClientManagementFiltersAppliedWarningMessage>
                                </React.Fragment>
                            )}
                        </div>
                        <div className="d-flex flex-fill justify-content-end align-items-center gap-2">
                            <FormInputWithSearchIcon
                                className="w-25"
                                placeholder="Search clients..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            <IconButton 
                                icon={['fas', 'filter']} 
                                onClick={() => setIsFiltersShown(true)}
                                menu={[
                                    <Wp3Dropdown.Menu>
                                        <Wp3Dropdown.MenuItem icon={['fas', 'plus']} text="Create new Client Set" onClick={() => setShowCreateSetModal(true)} />
                                    </Wp3Dropdown.Menu>
                                ]}
                            >
                                Filter Clients
                            </IconButton>
                        </div>
                    </div>
                </ClientManagementPageSubHeader>
                <section className="px-4 my-3 h-100">
                    <ClientManagementGrid
                        searchTerm={searchTerm}
                        showCreateSetModal={showCreateSetModal} 
                        setShowCreateSetModal={setShowCreateSetModal} 
                    />
                </section>
            </Main>
        </React.Fragment>
    );
};

export default ClientManagement;
